import { create } from 'zustand'
import { isPaletteId, isThemeMode, type PaletteId, type ThemeMode } from '@/theme'

const PALETTE_KEY = 'catering:palette'
const MODE_KEY = 'catering:mode'

interface AppearanceState {
  palette: PaletteId
  mode: ThemeMode
  setPalette: (palette: PaletteId) => void
  setMode: (mode: ThemeMode) => void
  toggleMode: () => void
}

/**
 * Reads the stored choice, falling back to the operating system preference for
 * mode so a dark-desktop user is not blinded on first load.
 */
function initialMode(): ThemeMode {
  const stored = localStorage.getItem(MODE_KEY)
  if (isThemeMode(stored)) return stored
  return window.matchMedia?.('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
}

function initialPalette(): PaletteId {
  const stored = localStorage.getItem(PALETTE_KEY)
  return isPaletteId(stored) ? stored : 'maroon'
}

export const useAppearanceStore = create<AppearanceState>((set, get) => ({
  palette: initialPalette(),
  mode: initialMode(),

  setPalette(palette) {
    localStorage.setItem(PALETTE_KEY, palette)
    set({ palette })
  },

  setMode(mode) {
    localStorage.setItem(MODE_KEY, mode)
    set({ mode })
  },

  toggleMode() {
    get().setMode(get().mode === 'dark' ? 'light' : 'dark')
  },
}))
